import { createFileRoute } from '@tanstack/react-router'
import { RegularLink } from '../../../components/inline/RegularLink'

export const Route = createFileRoute('/faq/privacy/')({
  component: PrivacyPage,
})

function PrivacyPage() {
  return (
    <div className="min-h-screen flex flex-col font-sans bg-stone-50 dark:bg-mist-950 text-stone-900 dark:text-white">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <RegularLink to="/faq" className="font-medium mb-8 inline-flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to FAQ
        </RegularLink>

        <h1 className="text-4xl font-bold mb-8 text-stone-900 dark:text-white">Privacy Policy</h1>

        <div className="prose prose-stone dark:prose-invert max-w-none space-y-6 text-stone-700 dark:text-stone-300">
          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">1. Introduction</h2>
            <p>
              Welcome to Sermon Slides ("we," "us," "our," or "Company"). We are committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">2. Information We Collect</h2>
            <p>We may collect information about you in a variety of ways. The information we may collect on the Site includes:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Personal Data:</strong> Name, email address, phone number, and other identifying information you provide when creating an account</li>
              <li><strong>Usage Data:</strong> Information about how you interact with our service, including slides viewed and devices used</li>
              <li><strong>Technical Data:</strong> IP address, browser type, operating system, and device information</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">3. Use of Your Information</h2>
            <p>Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. Specifically, we may use information collected about you via the Site to:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Create and manage your account</li>
              <li>Process your transactions and send related information</li>
              <li>Improve our service and user experience</li>
              <li>Send promotional communications (with your consent)</li>
              <li>Respond to your inquiries and support requests</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">4. Disclosure of Your Information</h2>
            <p>We do not sell, trade, or rent Users' personal identification information to others. We may share generic aggregated demographic information not linked to any personal identification information regarding visitors and users with our business partners, trusted affiliates, and advertisers.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">5. Security of Your Information</h2>
            <p>We use administrative, technical, and physical security measures to protect your personal information. However, perfect security does not exist on the Internet.</p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-stone-900 dark:text-white mt-8 mb-4">6. Contact Us</h2>
            <p>If you have questions or comments about this Privacy Policy, please contact us at:</p>
            <p className="text-stone-600 dark:text-stone-400">
              Email: <RegularLink href="mailto:support@sermon-slides.com">support@sermon-slides.com</RegularLink>
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
